import * as t from '../types';
import {GetPrivacyPolicy} from '../../services'


export const getPrivacy = () => async (dispatch) => {

    dispatch({
        type: t.GET_PRIVACY_POLICY_REQUEST
    });

    return await GetPrivacyPolicy()

        .then((data) => {
            dispatch({
                type: t.GET_PRIVACY_POLICY_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            dispatch({
                type: t.GET_PRIVACY_POLICY_FAILED,
                payload: err.response
            });
        });
};
